import { DEFAULT_ORDER_OPTION } from '@/shared/config';
import type { OrderOptions } from '@/shared/lib';

export const memberOrderOptions: OrderOptions[] = [
  { ...DEFAULT_ORDER_OPTION, label: 'Mais recente' },
  { label: 'Mais antigo', sort: 'createdAt', order: 'asc' },
  { label: 'Ordem alfabética crescente', sort: 'name', order: 'asc' },
  { label: 'Ordem alfabética decrescente', sort: 'name', order: 'desc' },
  { label: 'Maior número de matrícula', sort: 'registrationNumber', order: 'desc' },
  { label: 'Menor número de matrícula', sort: 'registrationNumber', order: 'asc' },
];
